import { Address } from "../contracts/address";

export class BranchAddress extends Address {
    branchName: string;
    isCopiedAddress: boolean = false;
}